import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';

import multiTransportConcept from '../../Assets/Images/multiTransportConcept11.png'; 
import desktopConcept from '../../Assets/Images/desktopConcept.png'; 
import contactConcept from '../../Assets/Images/contactConcept.png'; 
import formPlaceholder from '../../Assets/Images/formPlaceholder.png'; 
import formTopIcons from '../../Assets/Images/formTopIcons.svg'; 
import cornerTop from '../../Assets/Images/cornerTop.svg';
import cornerBottom from '../../Assets/Images/cornerBottom.svg';

import contactWhatsappIcon from '../../Assets/Images/contactWhatsappIcon.svg';
import contactEmailIcon from '../../Assets/Images/contactEmailIcon.svg';
import contactPhoneIcon from '../../Assets/Images/contactPhoneIcon.svg';
import transportPicture from '../../Assets/Images/transportPicture.svg';
import rentcarPicture from '../../Assets/Images/rentcarPicture.svg';
import transferPicture from '../../Assets/Images/transferPicture.svg';
import transportIcon from '../../Assets/Images/transportIcons.svg';
import transferIcon from '../../Assets/Images/transferIcon.svg';
import rentcarIcon from '../../Assets/Images/rentcarIcon.svg';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

// Load Componentes
import MessageView from '../../Components/MessageModal';
import AlertView from '../../Components/AlertModal';
import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone
} from '../../Components/Utils';

import {
	Callto,
	Whatsapp
} from '../../Components/Utils';

// export default function HomePage() {
const HomePage = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog
} = props;

const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })

const [email, setEmail] = React.useState('');
const [password, setPassword] = React.useState('');
const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

const [forgotPassword, setForgotPassword] = React.useState(false); 		

// set Use of history for PUSH 
var navigate = useNavigate();
	
/* Execute recaptcha to retrieve token*/
const recaptchaRef = window.grecaptcha;
const executeReCaptcha = async () => {
	const token = await recaptchaRef.execute();
	return token;
}

// Run after mount component
React.useEffect(() => {

	// Retrieve User Data Obj. 
	var result = localStorage.getItem("@dream4/userData", undefined,true);
	var userData = JSON.parse(result);  

	  // If token dont exist, redirect to onboarding or register
	  if (!userData) {
		  navigate("/home");
		  return;
	  } // end if

  // set scroll to top
  window.scrollTo(0, 1);
  
  // set loading false
  setLoading(false);
    
  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, []); // end useEffect 

// Navigate to Method
const pickTransportType = (target) => {
	
	setLoading(true);
	
	// Clean store filters
	// ...	
	
	// Wait 1 sec and redirect
	setTimeout(function() {
		
		if (target == "transport") {
			
			navigateTo("/order/transport");
			
		} // end if
		else if (target == "transfer") {
			
			navigateTo("/order/transfer");
			
		} // end else if
		else if (target == "rentcar") {
			
			navigateTo("/order/rentcar");
			
		} // end else if		
		
	},1000)	
	
}

// Navigate to Method
const navigateTo = (target) => {
	navigate(target);
}
 
  return (
	<>
	<div id="loginSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{minHeight:"728px",height:"728px"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		
			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start"}}>
						
				<div style={{flex:1,margin:"2rem",marginTop:"60px",minHeight:"520px",marginLeft:"auto",marginRight:"auto"}}>
				
					<div style={{fontSize:"28px",textAlign:"center",letterSpacing:"0.1em",lineHeight:"120%",fontWeight:"600",fontStyle:"normal",fontFamily:"Titillium Web",color:"#2E0249",flex:"1"}} className={loading ? "selectBoxTitle" : "selectBoxTitle animate"}>Selecione o tipo de deslocamento</div>
					
					<div style={{display:"flex",flexDirection:isTabletOrMobile ? "column" : "row",alignItems:"center",justifyContent:"center",gap:"15px",marginTop:"20px"}}> 
					
						<div style={{marginLeft:"auto",marginRight:"auto",display:"flex",flexDirection:isTabletOrMobile ? "column" : "row",alignItems:"center",justifyContent:"center",gap:"15px",marginTop:"20px"}}  className="selectBox">
					
						<div className={loading ? "imagem-zoom serviceSelector" : "imagem-zoom serviceSelector animate"} style={{minHeight:"459px",minWidth:"311px",backgroundColor:"white",borderRadius:"10px",padding:"25px"}} onClick={()=>{pickTransportType('transport')}}>
							
							<div style={{width:"261px",height:"180px",backgroundColor:"#EAE9F4",borderRadius:"10px"}}><img src={transportPicture} style={{width:"100%",height:"auto"}} className="noSelect" /></div>
							<div style={{width:"261px",minHeight:"200px",backgroundColor:"#FFF"}}> 
								<div style={{textAlign:"left",minHeight:"50px",marginTop:"23px"}}>
								<svg width="93" height="44" viewBox="0 0 93 44" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect width="44" height="44" rx="22" fill="#2E0249" fill-opacity="0.05"/>
								<path className="svgFillElement" d="M11.5312 28.1774V29.0002H30.2731V28.1774H24.2627H20.7397H11.5312Z" fill="#2E0249"/>
								<path className="svgFillElement" d="M17.8189 14.2913C16.4985 14.2913 16.0361 14.2911 15.9089 14.291C16.0501 14.2912 16.3891 14.2921 14.0611 14.2951C13.7568 14.2955 11.5392 14.291 11.5392 14.291C11.5357 15.0771 11.5336 15.4741 11.5324 16.702C12.4002 16.7026 13.1034 17.4062 13.1034 18.2741C13.1034 19.1424 12.3995 19.8462 11.5312 19.8462C11.5314 22.4621 11.5339 25.8098 11.5354 27.3338C11.5354 27.3338 12.5771 27.3461 12.7168 27.3463C13.7397 27.3482 13.1896 27.3483 14.2124 27.3418C14.2767 27.3414 15.2939 27.34 19.3491 27.3385C19.6127 27.8372 20.1364 28.1772 20.7397 28.1772C21.3434 28.1772 21.8674 27.8367 22.1308 27.3375C22.3794 27.3374 22.6266 27.3373 22.8715 27.3372C23.1349 27.8366 23.6589 28.1772 24.2628 28.1772C24.867 28.1772 25.3914 27.8361 25.6545 27.3362C27.885 27.3354 29.5429 27.3347 29.7721 27.3343C30.5853 27.3333 31.0396 27.2075 31.5098 26.9254C38.1238 23.3732 23.5755 14.6008 17.8189 14.2913ZM15.7514 19.8462C14.8831 19.8462 14.1793 19.1423 14.1793 18.274C14.1793 17.4057 14.8831 16.7019 15.7514 16.7019C16.6197 16.7019 17.3236 17.4057 17.3236 18.274C17.3236 19.1423 16.6197 19.8462 15.7514 19.8462ZM29.4844 21.428L24.9126 20.6103C24.7952 20.5934 22.0768 20.0666 21.1365 20.1107L18.0893 20.1253V16.0129H20.7452C20.8952 16.0129 21.0442 16.0365 21.1871 16.0819C25.2566 17.3781 29.7237 20.8508 29.7237 20.8508C29.9652 21.0576 29.8014 21.4527 29.4844 21.428Z" fill="#2E0249"/>
								<rect x="49" width="44" height="44" rx="22" fill="#2E0249" fill-opacity="0.05"/>
								<path className="svgFillElement" d="M68.6664 27.7841C68.2336 29.1178 67.056 29.9999 65.7079 30C64.3756 30.0001 63.2027 29.1324 62.7687 27.8132C62.7218 27.6705 62.655 27.643 62.5235 27.6439C61.5608 27.6502 62.0785 27.65 61.1158 27.6482C60.9844 27.648 60.8488 27.6449 60.7224 27.6128C60.2747 27.4991 60.0045 27.0896 60.0039 26.521C60.0011 23.6719 59.9953 20.8227 60.0074 17.9736C60.0093 17.519 60.0658 17.0583 60.1527 16.6119C60.3049 15.8296 60.7313 15.2691 61.5229 15.0919C61.8021 15.0294 62.0946 15.0044 62.381 15.004C66.4607 14.9986 64.3658 15.0002 68.4455 15.0003C71.6526 15.0004 74.8599 15.0013 78.067 15C78.8527 14.9997 79.5207 15.2816 80.0714 15.8598C80.5301 16.3413 80.8415 16.9176 81.0798 17.5374C81.6575 19.0397 81.8502 20.6206 81.9487 22.2167C82.0377 23.6587 82.0016 25.101 81.9116 26.5423C81.8627 27.3246 81.5444 27.6356 80.7789 27.6366C80.0449 27.6376 79.3106 27.6447 78.5767 27.6315C78.3931 27.6281 78.3278 27.6887 78.2653 27.862C77.8623 28.9804 77.0888 29.6973 75.9545 29.929C74.785 30.1678 73.7822 29.7998 72.983 28.8794C72.6738 28.5232 72.4739 28.1029 72.339 27.6453C69.5649 27.6453 71.4921 27.6453 68.7153 27.6453C68.695 27.703 68.6797 27.7432 68.6664 27.7841ZM73.797 20.1181C75.3981 20.4425 76.6265 21.4319 77.8275 22.4719C78.3382 22.9141 78.8419 23.3659 79.3696 23.7857C79.5727 23.9473 79.8247 24.0597 80.0709 24.1432C80.2955 24.2194 80.4035 24.1253 80.4101 23.8804C80.427 23.2493 80.4463 22.6173 80.4307 21.9866C80.4054 20.9652 80.3104 19.9494 80.0732 18.9537C79.9094 18.2658 79.6918 17.5991 79.2589 17.0315C78.8875 16.5445 78.4107 16.2897 77.7967 16.2945C76.5273 16.3045 75.2578 16.2975 73.9883 16.2975C73.9294 16.2975 73.8704 16.2975 73.797 16.2975C73.797 17.5878 73.797 18.8498 73.797 20.1181ZM66.5038 16.2974C66.4325 16.2974 66.3684 16.2974 66.3044 16.2974C64.9934 16.2974 63.6826 16.2971 62.3716 16.2981C62.2696 16.2981 62.1657 16.2953 62.0659 16.3129C61.6229 16.3906 61.3792 16.6635 61.3418 17.2148C61.2971 17.8741 61.2972 18.5366 61.282 19.1979C61.2774 19.3957 61.2851 19.5939 61.2902 19.7919C61.2947 19.9624 61.3802 20.0587 61.5483 20.0587C63.1839 20.0588 64.8194 20.0572 66.455 20.0556C66.4657 20.0556 66.4765 20.0478 66.5038 20.0371C66.5038 18.7941 66.5038 17.5577 66.5038 16.2974ZM67.7396 16.3067C67.7396 17.5507 67.7396 18.7959 67.7396 20.0505C69.3062 20.0505 70.8678 20.0505 72.4439 20.0505C72.4439 18.8108 72.4439 17.5701 72.4439 16.3067C70.8771 16.3067 69.3156 16.3067 67.7396 16.3067ZM73.6125 26.8369C73.6223 27.7993 74.4003 28.5809 75.3449 28.5775C76.3047 28.5741 77.0794 27.7742 77.0748 26.7915C77.0702 25.8105 76.2837 25.0144 75.3283 25.0234C74.3577 25.0326 73.6023 25.8311 73.6125 26.8369ZM67.4389 26.7689C67.4297 25.7966 66.6462 25.0133 65.6929 25.0236C64.7342 25.0338 63.964 25.8413 63.9765 26.8228C63.989 27.7964 64.7723 28.5858 65.7183 28.5781C66.6892 28.5702 67.4484 27.7719 67.4389 26.7689Z" fill="#2E0249"/>
								</svg>
								</div>
									<div style={{marginTop:"12px"}}>
										<div style={{textAlign:"left",fontFamily: "'Titillium Web'",fontStyle: 'normal',fontWeight: 600,fontSize: '18px',lineHeight: '120%',letterSpacing: '0.1em',color: '#2E0249'}} className="title">Buscar por passagens de Trem e Ônibus</div>
										<div style={{textAlign:"left",fontFamily: 'Titillium Web', fontStyle: 'normal', fontWeight: 400, fontSize: '14px', lineHeight: '120%', letterSpacing: '0.1em', color: '#0E0E0E', opacity: 0.8, marginTop:"10px" }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelue dolor mi mattis facili dui pretium suspendisse pisctis.</div>									
									</div>
							</div>							

						</div>
						
						<div className={loading ? "imagem-zoom serviceSelector" : "imagem-zoom serviceSelector animate"} style={{minHeight:"459px",minWidth:"311px",backgroundColor:"white",borderRadius:"10px",padding:"25px"}} onClick={()=>{pickTransportType('transfer')}}>

							<div style={{width:"261px",height:"180px",backgroundColor:"#EAE9F4",borderRadius:"10px"}}><img src={transferPicture} style={{width:"100%",height:"auto"}} className="noSelect" /></div>
							<div style={{width:"261px",minHeight:"200px",backgroundColor:"#FFF"}}> 
								<div style={{textAlign:"left",minHeight:"50px",marginTop:"23px"}}><svg style={{width:"auto",height:"44px"}} className="noSelect" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="44" height="44" rx="22" fill="#2E0249" fill-opacity="0.05"/>
									<path className="svgFillElement" d="M22.354 16.9983C23.8224 16.9994 25.2028 16.2982 26.068 15.1118C26.6727 14.2848 26.9985 13.2941 27 12.2776V11.8866C27 10.5906 26.4732 9.34768 25.5355 8.43126C24.5979 7.51484 23.3261 7 22 7C20.6739 7 19.4021 7.51484 18.4645 8.43126C17.5268 9.34768 17 10.5906 17 11.8866V12.2776C17.0012 13.2939 17.3266 14.2847 17.931 15.1118C18.7965 16.2961 20.1749 16.9967 21.6418 16.9978L22.354 16.9983Z" fill="#2E0249"/>
									<path className="svgFillElement" d="M22 32C27.5225 32 32 28.7721 32 24.7909C32 22.2458 30.1708 20.008 27.4077 18.7255C26.2594 18.1925 24.9617 18.8118 24.3998 19.9462C23.4161 21.9321 20.5836 21.9324 19.5996 19.9466C19.0374 18.812 17.7391 18.1931 16.5907 18.7266C13.8288 20.0097 12 22.2461 12 24.7909C12 28.7721 16.4775 32 22 32Z" fill="#2E0249"/>
									<rect className="svgFillElement" x="13" y="24" width="18" height="13" rx="1" fill="#2E0249"/>
									<rect className="svgFillElement" x="13.5" y="24.5" width="17" height="12" rx="0.5" fill="#2E0249" stroke="white"/>
									<path d="M20.9481 32.9659C20.7508 33.5883 20.2141 34 19.5997 34C18.9925 34 18.4579 33.5951 18.2601 32.9795C18.2387 32.9129 18.2083 32.9001 18.1484 32.9005C17.7096 32.9034 17.9456 32.9033 17.5068 32.9025C17.4469 32.9024 17.3851 32.901 17.3275 32.886C17.1234 32.8329 17.0003 32.6418 17 32.3765C16.998 30.3198 18.1088 30.1817 18.1973 28.3877C18.1982 28.1755 18.2239 27.9605 18.2635 27.7522C18.3329 27.3871 18.5272 27.1256 18.888 27.0429C19.0152 27.0137 19.1485 27.002 19.2791 27.0019C21.1385 26.9993 18.988 27.0001 20.8474 27.0001C22.3092 27.0002 20.7588 27.0006 22.2205 27C22.5786 26.9999 22.883 27.1314 23.134 27.4012C23.3431 27.626 24.0896 28.9517 24.2429 29.2175C24.635 29.897 26.0146 29.3093 26.7948 30.7071C26.9906 31.2072 27.0258 31.7138 26.9848 32.3864C26.9626 32.7515 26.8175 32.8966 26.4686 32.8971C26.1341 32.8976 25.7994 32.9009 25.4649 32.8947C25.3812 32.8931 25.3514 32.9214 25.323 33.0023C25.1393 33.5242 24.7868 33.8587 24.2698 33.9668C23.7368 34.0783 23.2797 33.9066 22.9155 33.477C22.6661 33.1829 22.3562 32.9011 21.9706 32.9011C21.6888 32.9011 21.8721 32.9011 21.0404 32.9011C20.9994 32.9011 20.9605 32.9268 20.9481 32.9659ZM20.2743 28.5884C20.2743 29.0543 20.6011 29.4575 21.0602 29.5372C21.765 29.6595 22.6051 29.7769 23.1438 29.7769C23.325 29.7769 23.4375 29.7424 23.501 29.6824C23.8832 29.3212 23.2486 28.7196 22.9772 28.2691C22.9065 28.1518 22.8552 28.0708 22.7637 27.948C22.5944 27.7207 22.3771 27.6018 22.0973 27.604C21.5187 27.6087 20.9401 27.6054 20.3615 27.6054C20.3134 27.6054 20.2743 27.6445 20.2743 27.6926C20.2743 27.9937 20.2743 28.2916 20.2743 28.5884ZM19.9625 27.6964C19.9625 27.6462 19.9218 27.6054 19.8715 27.6054C19.2741 27.6054 19.8723 27.6053 19.2748 27.6057C19.2283 27.6058 19.181 27.6045 19.1354 27.6126C18.9336 27.6489 18.8225 27.7763 18.8054 28.0335C18.785 28.3412 18.7851 28.3354 18.7781 28.644C18.7761 28.7363 18.7796 28.8288 18.7819 28.9212C18.7839 29.0007 18.8335 29.0048 18.8995 29.0457C19.2067 29.2359 19.3118 29.2952 19.9402 29.3593C19.9547 29.3593 19.9624 29.3412 19.9624 29.3267C19.9625 28.7846 19.9625 28.245 19.9625 27.6964ZM23.2024 32.5239C23.2068 32.973 23.5614 33.3377 23.9919 33.3362C24.4293 33.3346 24.7825 32.9613 24.7804 32.5027C24.7783 32.0449 24.3968 31.6733 23.9613 31.6776C23.519 31.6819 23.1977 32.0545 23.2024 32.5239ZM20.3886 32.4921C20.3844 32.0384 20.0273 31.6729 19.5929 31.6776C19.1559 31.6824 18.8049 32.0592 18.8106 32.5173C18.8163 32.9716 19.1732 33.34 19.6044 33.3364C20.0469 33.3327 20.3929 32.9602 20.3886 32.4921Z" fill="white"/>
									</svg></div>
									<div style={{marginTop:"12px"}}>
									<div style={{textAlign:"left",fontFamily: "'Titillium Web'",fontStyle: 'normal',fontWeight: 600,fontSize: '18px',lineHeight: '120%',letterSpacing: '0.1em',color: '#2E0249'}} className="title">Contratar um Transfer</div>
									<div style={{textAlign:"left",fontFamily: 'Titillium Web', fontStyle: 'normal', fontWeight: 400, fontSize: '14px', lineHeight: '120%', letterSpacing: '0.1em', color: '#0E0E0E', opacity: 0.8, marginTop:"10px" }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelue dolor mi mattis facili dui pretium suspendisse pisctis.</div>								
								</div>
							</div>

						</div>

						<div className={loading ? "imagem-zoom serviceSelector" : "imagem-zoom serviceSelector animate"} style={{minHeight:"459px",minWidth:"311px",backgroundColor:"white",borderRadius:"10px",padding:"25px"}} onClick={()=>{pickTransportType('rentcar')}}>

							<div style={{width:"261px",height:"180px",backgroundColor:"#EAE9F4",borderRadius:"10px"}}><img src={rentcarPicture} style={{width:"100%",height:"auto"}} className="noSelect" /></div>
							<div style={{width:"261px",height:"200px",backgroundColor:"#FFF"}}> 
								<div style={{textAlign:"left",minHeight:"50px",marginTop:"23px"}}><svg style={{width:"auto",height:"44px"}} className="noSelect" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect y="6.10352e-05" width="44" height="44" rx="22" fill="#2E0249" fill-opacity="0.05"/>
									<path className="svgFillElement" d="M19.4754 27.6365C19.002 29.0591 17.7139 30 16.2393 30.0001C14.7819 30.0002 13.499 29.0746 13.0243 27.6675C12.9729 27.5152 12.8999 27.4859 12.7561 27.4868C11.703 27.4935 12.2693 27.4934 11.2163 27.4915C11.0726 27.4912 10.9242 27.4879 10.7859 27.4537C10.2962 27.3324 10.0006 26.8956 10 26.2891C9.99521 21.5882 12.6611 21.2726 12.8735 17.1718C12.8756 16.6869 12.9373 16.1955 13.0324 15.7194C13.1989 14.8849 13.6652 14.2871 14.5311 14.0981C14.8366 14.0314 15.1565 14.0047 15.4698 14.0043C19.9324 13.9985 14.7713 14.0003 19.2338 14.0004C22.742 14.0004 19.021 14.0014 22.5292 14.0001C23.3886 13.9997 24.1193 14.3005 24.7217 14.9172C25.2234 15.4309 27.015 18.4611 27.383 19.0685C28.324 20.6219 31.635 19.2784 33.5075 22.4734C33.9774 23.6166 34.062 24.7745 33.9636 26.3118C33.9102 27.1463 33.562 27.478 32.7247 27.4791C31.9217 27.4802 31.1186 27.4877 30.3158 27.4736C30.1149 27.4701 30.0435 27.5347 29.9752 27.7195C29.5343 28.9125 28.6883 29.6772 27.4476 29.9243C26.1684 30.179 25.0714 29.7865 24.1972 28.8047C23.603 28.1373 22.88 27.4884 21.9863 27.4884C21.2269 27.4884 21.7479 27.4884 19.6901 27.4884C19.5956 27.4884 19.5054 27.5468 19.4754 27.6365ZM17.8584 17.6209C17.8584 18.6893 18.6133 19.6111 19.6672 19.7865C21.3743 20.0706 23.4326 20.3472 24.7452 20.3472C25.8334 20.3472 25.8882 19.8541 25.6555 19.1861C25.4778 18.6761 25.1863 18.2138 24.8922 17.7609C24.3089 16.8627 24.2233 16.6662 23.8328 16.1669C23.4266 15.6474 22.905 15.3756 22.2335 15.3807C20.8449 15.3914 19.4563 15.3839 18.0677 15.3839C17.9521 15.3839 17.8584 15.4776 17.8584 15.5932C17.8584 16.2746 17.8584 16.949 17.8584 17.6209ZM17.1099 15.6022C17.1099 15.4816 17.0122 15.3839 16.8917 15.3839C15.4578 15.3839 16.8934 15.3837 15.4595 15.3846C15.3479 15.3847 15.2343 15.3817 15.1251 15.4004C14.6405 15.4833 14.3739 15.7745 14.333 16.3624C14.2841 17.0657 14.2842 17.0523 14.2675 17.7577C14.2626 17.9687 14.271 18.1802 14.2766 18.3913C14.2815 18.5732 14.4004 18.5824 14.5589 18.6759C15.296 19.1106 15.5483 19.2462 17.0564 19.3927C17.0909 19.3927 17.1098 19.3502 17.1098 19.3158C17.1099 18.0809 17.1099 16.8518 17.1099 15.6022ZM24.8857 26.626C24.8964 27.6526 25.7473 28.4863 26.7807 28.4827C27.8304 28.479 28.6779 27.6258 28.6729 26.5777C28.6679 25.5313 27.7524 24.682 26.7072 24.6917C25.6456 24.7015 24.8745 25.5531 24.8857 26.626ZM18.1327 26.5535C18.1226 25.5164 17.2656 24.6809 16.2229 24.6918C15.1742 24.7028 14.3317 25.564 14.3454 26.611C14.359 27.6495 15.2158 28.4916 16.2506 28.4834C17.3127 28.4749 18.1431 27.6234 18.1327 26.5535Z" fill="#2E0249"/>
									</svg></div>
								<div style={{marginTop:"12px"}}>
									<div style={{textAlign:"left",fontFamily: "'Titillium Web'",fontStyle: 'normal',fontWeight: 600,fontSize: '18px',lineHeight: '120%',letterSpacing: '0.1em',color: '#2E0249'}} className="title">Alugar um Carro</div>
									<div style={{textAlign:"left",fontFamily: 'Titillium Web', fontStyle: 'normal', fontWeight: 400, fontSize: '14px', lineHeight: '120%', letterSpacing: '0.1em', color: '#0E0E0E', opacity: 0.8, marginTop:"10px"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelue dolor mi mattis facili dui pretium suspendisse pisctis.</div>								
								</div>
							</div>	

						</div>

						</div>						

						
					</div>				
				
				</div>
			
			</div> 
		</div>
    </div>
	
	<div id="contatoSection" className="contatoSection__wrapper">

		<div className={isTabletOrMobile ? "contatoSection__wrapper_content_wrapper mobile" : "contatoSection__wrapper_content_wrapper"}  >

			<div className="flex-1 dFlex aItemsC jContentE"> 
			
				<div className="textBlockMargin contatoSection__wrapper_content_text" >
				
					<div className="contatoSection__wrapper_content_header">Central de Relacionamento</div>
				
					Estamos a disposição para atender às suas necessidades e responder às suas perguntas. Conheça as principais formas de entrar em contato conosco:
					
					<div style={{marginTop: "2.8125rem", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "stretch", gap: "15px"}}>

						<div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center",gap:"15px"}}>
							<div><img src={contactWhatsappIcon} style={{width:"49px",height:"auto"}} className="noSelect" /></div>
							<div className="contatoOptionText"><Whatsapp phone="552140209749" style={{color:"#FFF",textDecoration:"none"}}>Whatsapp 4020-9749</Whatsapp></div>
						</div>

						<div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center",gap:"15px"}}>
							<div><img src={contactPhoneIcon} style={{width:"49px",height:"auto"}} className="noSelect"  /></div>
							<div className="contatoOptionText"><Callto phone="+552140209749" style={{color:"#FFF",textDecoration:"none"}}>Telefone 4020-9749</Callto></div>
						</div>
						
						<div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center",gap:"15px"}}>
							<div><img src={contactEmailIcon} style={{width:"49px",height:"auto"}} className="noSelect"  /></div>
							<div className="contatoOptionText"><Button label="Enviar mensagem" rounded className="pT10 mR10 headerButton tColorWhite w100" style={{marginBottom:"0.625rem"}} onClick={()=>setDialog('messageModal',true)} /></div>
						</div>
						

					</div>					
				
				</div> 
				
			</div>
			
			<div className="tAlignL flex-1_5"> 
				<img src={contactConcept} className="contatoSection__wrapper_content_image noSelect" />
			</div>			
			
		</div>
			<AlertView
				alert={alert}
				setAlert={setAlert}
				alertTitle={alertTitle}
				alertBody={alertBody}	
				scrollBlock={false}				
			/>	
			<MessageView
				alert={alert}
				setAlert={setAlert}
				alertTitle={alertTitle}
				alertBody={alertBody}	
				scrollBlock={false}				
			/>	
    </div>
	
	<div id="memovoSection" className="memovoSection__wrapper">
	
		<div className={isTabletOrMobile ? "memovoSection__wrapper_content_wrapper mobile" : "memovoSection__wrapper_content_wrapper"}>
		
			<div className="flex-1"> 
				<img src={desktopConcept} className="memovoSection__wrapper_content_image noSelect" />
			</div>
			<div className="flex-1 dFlex aItemsC jContentS"> 
			
				<div className="textBlockMargin memovoSection__wrapper_content_text" >
				
					<div className="memovoSection__wrapper_content_header">Inovando o Mercado B2B de Mobilidade</div>
									
					A MEMOVO é uma plataforma B2B inovadora que facilita a busca e comercialização de serviços de transporte e mobilidade. Pioneira como marketplace B2B, oferece passagens aéreas, trens, ônibus, aluguel de veículos e transfers em um só lugar, permitindo a criação de roteiros completos de mobilidade. Com interface amigável e processo simples, a plataforma proporciona agilidade e eficiência aos profissionais do setor, atendendo às necessidades dos usuários e impulsionando o crescimento do seu negócio.
				
				</div> 
				
			</div>
			
		</div>
		
    </div>	
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(HomePage);	


